import React from "react";

const PHOTOS = [
  {
    src: "https://customer-assets.emergentagent.com/job_86572a60-f169-4826-bdbe-647ca27ec590/artifacts/v7e44kbi_IMG-20260420-WA0007.jpg",
    caption: "Cercle de femmes — accueil au Sanctuaire",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_86572a60-f169-4826-bdbe-647ca27ec590/artifacts/1ihak0st_IMG-20260420-WA0008.jpg",
    caption: "Atelier collectif — la parole circule",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_86572a60-f169-4826-bdbe-647ca27ec590/artifacts/7cgxaqtk_IMG-20260420-WA0009.jpg",
    caption: "Cuisine collective — transmission gourmande",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_86572a60-f169-4826-bdbe-647ca27ec590/artifacts/o07o4uq9_IMG-20260420-WA0010.jpg",
    caption: "Atelier de soin — rituel du corps",
  },
];

export default function Galerie() {
  return (
    <section
      id="galerie"
      data-testid="galerie-section"
      className="bg-[#FAF7F2] py-24 lg:py-36"
    >
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div>
            <p className="sdm-divider">Galerie</p>
            <h2 className="font-serif-display text-4xl lg:text-6xl text-[#4A192C] mt-6 leading-tight">
              Traces d&apos;une vie <em className="text-[#C5A059]">retrouvée.</em>
            </h2>
          </div>
          <p className="text-[#6B585F] max-w-md">
            Moments capturés lors de nos ateliers et cercles de parole. Les
            visages témoignent de la joie simple de se retrouver entre sœurs.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 lg:gap-4">
          {PHOTOS.map((p, i) => (
            <figure
              key={i}
              data-testid={`gallery-photo-${i + 1}`}
              className="group relative aspect-[4/5] overflow-hidden"
            >
              <img
                src={p.src}
                alt={p.caption}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
              />
              <figcaption className="absolute inset-0 bg-[#4A192C]/0 group-hover:bg-[#4A192C]/70 transition-colors duration-500 flex items-end p-5 opacity-0 group-hover:opacity-100">
                <span className="text-[#FAF7F2] font-serif-display text-lg italic leading-snug">
                  {p.caption}
                </span>
              </figcaption>
              <div className="absolute top-3 left-3 w-7 h-7 border border-[#C5A059]/70 bg-[#FAF7F2]/80 flex items-center justify-center text-[0.62rem] font-semibold text-[#4A192C]">
                {String(i + 1).padStart(2, "0")}
              </div>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
